<div *ngIf="isLoading" class="loading-spinner">
	<div class="spinner"></div>
	<div class="message">{{ message }}</div>
</div>
